import { formatJapaneseYearMonthDay, formatHourMinute } from "@p-ban/common/src/utils/DateUtils"

import type { SeminarValues } from "../api/seminarApi"

export const formatSeminarDateTime = (seminar: SeminarValues) => {
  const seminarDate = seminar.seminarDate ? formatJapaneseYearMonthDay(seminar.seminarDate) : ""
  const startTime = seminar.startTime ? formatHourMinute(seminar.startTime) : ""
  const endTime = seminar.endTime ? formatHourMinute(seminar.endTime) : ""

  return `${seminarDate} ${startTime}-${endTime}`
}

export const formatSite = (seminar: SeminarValues) => {
  return seminar.onlineSeminar ? "オンラインでの開催となります。" : seminar.site
}
